import useCollectedFilters from '../../trimLevels/hooks/useCollectedFilters';
import IVehiclePayload from '../../gqlCommon/model/IVehiclePayload';
import { useEffect, useState } from 'react';
import useCustomizeCarContext from './useCustomizeCarContext';

const useVehiclePayload: () => IVehiclePayload = () => {
  const { filters } = useCollectedFilters();
  const { selectedCar } = useCustomizeCarContext();

  const [vehiclePayload, setVehiclePayload] = useState(null);

  useEffect(() => {
    if (selectedCar) {
      setVehiclePayload({
        vehicleId: selectedCar.car?.code,
        dms: selectedCar.stockInfo?.dms,
        vin: selectedCar.stockInfo?.vin,
      });
    }
  }, [selectedCar]);

  return { ...filters, ...vehiclePayload };
};

export default useVehiclePayload;
